import { CommonServices } from "@/services/CommonServices";
import * as OM from '@/model'
import store from "@/store";
import { StorageServices } from "./StorageServices";
import router, { getMenuByRole } from "@/router";
import { CommessaClient, LoginClient, UserClient } from "./Services";
import { DownloadedFilesServices } from "./DownloadedFilesServices";


class _LoginServices {

    loginCallback(token: string){
        CommonServices.setAuthToken(token);

        return new Promise<void>((resolve, reject) => {
            UserClient.getSelf()
            .then(user => {
                store.state.user = user;
                StorageServices.setUser(user);

                if(window.cordova){
                    DownloadedFilesServices.reload();
                }

                Promise.all([
                    store.state.updateSubscription(),
                    CommessaClient.getOwnedByUser(store.state.user.identifier),
                    CommessaClient.getEnabledParticipatedByUser(store.state.user.identifier)
                ])
                .then(xs => {
                    store.state.commesse.ownedCommessas = xs[1];
                    store.state.commesse.invitedCommessas = xs[2];
                    var allCommessas = [...xs[1], ...xs[2]];
                    if(allCommessas.length == 1){
                        store.state.commesse.selectCommessa(allCommessas[0])
                        .then(_ => resolve())
                    } else {
                        let storedCommessa = StorageServices.getSelectedCommessa();
                        var matching = allCommessas.find(x => x.identifier == storedCommessa);
                        if(storedCommessa && matching){
                            store.state.commesse.selectCommessa(matching)
                            .then(_ => resolve())
                        } else {
                            resolve();
                        }
                    }
                })
            })
            .catch(err => reject(err))
        });
    }

    impersonateUser(userIdentifier: string){
        const originalToken = CommonServices.getAuthToken();
        StorageServices.setSuperAdminToken(originalToken);

        return LoginClient.impersonateUser(userIdentifier)
        .then(token => {
            this.loginCallback(token)
            .then(_ => {
                let menu = getMenuByRole(store.state.user.role)
                if(menu.commessaPaths[0]){
                    router.push(menu.commessaPaths[0].path);
                } else {
                    router.push(menu.systemPaths[0].path);
                }
            })
        });
    }

    exitImpersonation(){
        const originalToken = StorageServices.getSuperAdminToken();
        StorageServices.removeSuperAdminToken();

        store.state.commesse.selectedCommessa = null;
        StorageServices.setSelectedCommessa(null);

        return this.loginCallback(originalToken)
        .then(() => {
            let menu = getMenuByRole(store.state.user.role)
            if(menu.commessaPaths[0]){
                router.push(menu.commessaPaths[0].path);
            } else {
                router.push(menu.systemPaths[0].path);
            }
        });
    }

    logout(){
        return new Promise<void>((resolve) => {
            CommonServices.destroyToken();
            StorageServices.removeSuperAdminToken();
            store.state.user = null;
            store.state.commesse.selectedCommessa = null;
            store.state.commesse.roleInCommessa = '';
            StorageServices.setSelectedCommessa(null);
            DownloadedFilesServices.reload();
            resolve();
        });
    }
}

export let LoginServices = new _LoginServices();
